module.exports = __webpack_public_path__ + "img/1.1edb6da0.jpg";